import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-breadcrumb-gallery',
  templateUrl: './breadcrumb-gallery.component.html',
  styleUrls: ['./breadcrumb-gallery.component.scss']
})
export class BreadcrumbGalleryComponent {

  @Input() header: string;
  @Input() subHeader: string;

  constructor() { }

  gallery = [
    {
      img: 'bg1'
    },
    {
      img: 'bg2'
    },
    {
      img: 'bg3'
    },
    {
      img: 'bg4'
    }
  ];

  galleryCarouselOptions = {
    items: 1,
    nav: true,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    autoplay: true,
    slideSpeed: 500,
    paginationSpeed: 300,
    loop: true,
    dots: false,
    animateOut: 'fadeOut'
  };
}
